import { DEDUCTION } from '../evidence';
import { VAT_FILTERS } from './vatEvidenceFilters';
import { VAT_REGISTER_TYPE_FILTER } from './EvidenceVatRegisterTypeFilter';

export const KPIR_PURCHASES_LISTING_FILTERS = {
  path: '/evidences/kpir-purchases',
  filters: [
    ...VAT_FILTERS,
    VAT_REGISTER_TYPE_FILTER(DEDUCTION),
  ],
};
